import Vue from 'vue'
import eventBus from '@ms/utils/event-bus.js'
import parsePushData from 'custom-push/pushParser/parsePushData'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'
import { prefillMatchSummary } from '@ms/components/match/useMatchInfo.js'
import { turnTournamentsToMap, turnMarketsToMap as turnCommentaryMarketsToMap } from '@ms/utils/eventHandlers/convert'
import { updateEvent, updateMarket as updateCommentaryMarket, updateOutcome as updateCommentaryOutcome } from 'wap/utils/pushParser/update'
import { turnMarketsToMap, updateMarket, updateOutcome, updateMarketStatus } from '@ms/components/match/update-details.js'

export default {
  updateTab(tab = '') {
    this.currentTab = tab
    this.isCommentary = /Commentary/i.test(tab)
    if (this.isCommentary) {
      Vue.set(this.event, 'markets', { order: [], map: {} })
    }
  },
  updateEventId(eventId = '') {
    this.eventId = eventId
  },

  resetEvent() {
    this.event.status = -1
    this.currentTab = 'Market'
    this.isCommentary = /Commentary/i.test(this.currentTab)
    if (this.isCommentary) {
      Vue.set(this.event, 'markets', { order: [], map: {} })
    }
  },

  setMatchDetail(data) {
    if (data) {
      const { markets = { order: [], map: {} }, ...rest } = data
      this.event = {
        ...rest,
        markets: turnMarketsToMap(markets)
      }
    }
  },

  updateMatchDetail(data) {
    const { order, map } = this.event.markets
    const marketList = Array.isArray(data) ? data : [data]
    const marketInfo = turnMarketsToMap(marketList)
    marketInfo.order.forEach((id) => {
      if (!marketInfo.map[id]) {
        order.push(id)
        Vue.set(map, id, marketInfo.map[id])
      }
    })
  },

  setMarketGroupList(markets = []) {
    this.marketGroupList = markets
  },

  allFavoriteMarketIds(data = []) {
    this.favouriteMarketIds = data
  },

  // 添加/取消收藏 market
  updateFavouriteMarket({ marketId = '', status = true }) {
    const index = this.favouriteMarketIds.findIndex((x) => +x === +marketId)
    if (status) {
      if (index === -1) {
        this.favouriteMarketIds.unshift(+marketId)
      }
    } else {
      this.favouriteMarketIds.splice(index, 1)
    }
  },

  setLiveMatches({ tournaments = [] }) {
    this.liveMatches = turnTournamentsToMap(tournaments)
  },

  // 更新推送信息
  updateMatch(data) {
    const eventInfo = parsePushData(data, 'event')
    const topicInfo = parseTopicInfo(data.topic, 'event')
    const { eventId } = topicInfo
    const { event } = this

    // 验证 eventId，有可能有旧数据
    if (eventId === event.eventId) {
      // pushTime直接合并上去，不受监控
      if ((event.pushTime && event.pushTime < eventInfo.pushTime) || !event.pushTime) {
        // 更新比赛信息
        const betStatus = eventInfo.betStatus
        delete eventInfo.betStatus
        if (!eventInfo.soccerBookingsScore) delete eventInfo.soccerBookingsScore
        if (!eventInfo.soccerCornerScore) delete eventInfo.soccerCornerScore
        Object.assign(event, eventInfo)
        prefillMatchSummary(event)

        if (event.markets && event.markets.length && betStatus && (betStatus === 1 || betStatus === 2)) {
          updateMarketStatus(event.markets, betStatus)
        }
      }
    }
  },

  updateMarket(data) {
    const topicInfo = parseTopicInfo(data[0], 'market')
    const { eventId } = topicInfo
    const { event } = this
    // 验证 eventId，有可能有旧数据
    if (eventId === event.eventId) {
      if (this.isCommentary) {
        updateCommentaryMarket(this.event, data)
      } else {
        updateMarket(this.event, data)
      }
    }
  },

  updateOutcome(data) {
    const topicInfo = parseTopicInfo(data[0], 'market')
    const { eventId } = topicInfo
    const { event } = this
    // 验证 eventId，有可能有旧数据
    if (eventId === event.eventId) {
      if (this.isCommentary) {
        updateCommentaryOutcome(this.event, data)
      } else {
        updateOutcome(this.event, data)
      }
    }
  },

  updateLiveMatches(data) {
    const topicInfo = parseTopicInfo(data.topic, 'event')
    if (topicInfo) {
      const { liveMatches } = this
      const { tournamentId } = topicInfo
      if (!liveMatches.map) return
      const tournament = liveMatches.map[tournamentId]

      if (tournament) {
        const { map, order } = tournament.events
        updateEvent(map, order, data)
      }
    }
  },

  updateCommentaryHistoryList(list = []) {
    this.commentaryHistoryList = list
  },
  liveCommentary(data) {
    this.liveCommentaryStatus = data.roomStatus // 直播状态 1：正常 2：暂停
    this.liveCommentaryHasVouvher = data.hasVoucher // 表示广告位
    this.liveCommentaryList.push(...data.commentaries) // 推送消息列表
    this.liveRemainCount = data.remainCount // 未查看条数
    this.HistoryNoMore = this.lastCommentaryId ? data.commentaries.length < 20 : false
    this.lastCommentaryId = data.lastCommentaryId || ''
  },
  updateCommentaryList(data) {
    const typeItem = data.commentaries.find((item) => item.commentaryType === 1)
    if (typeItem) {
      this.restartMessageShow = true
    }

    data.commentaries.forEach((item) => {
      item.isPushMsg = true
      const { commentaryType, moduleType } = item
      // if (moduleType === 3) {
      //   console.log('push market: ', item.commentaryText.map(x => x.marketId))
      // }
      if (moduleType === 5) {
        eventBus.$emit('live_commentary_handleAnime')
      }
      if (commentaryType === 1) {
        // live 消息
        this.liveCommentaryList.unshift(item)
      } else if (commentaryType === 2) {
        // 自建消息
        this.commentaryMessagePool.push(item)
      }
    })
  },

  // 推送消息从pool取出进行展示
  transformMessageFromPool() {
    const item = this.commentaryMessagePool.shift()
    this.liveCommentaryList.unshift(item)
  },

  // 改变自建消息倒计时开关
  updateMessageShowStatus(data) {
    this.restartMessageShow = data
  },

  // 改变当前底部展示类型
  updateCurrentFixedType(data) {
    this.currentFixedType = data || 0
  },
  // 改变当前底部展示类型
  updateCurrentFixedId(data) {
    this.currentFixedId = data || ''
  },
  resetLiveCommentary() {
    this.liveCommentaryStatus = ''
    this.liveCommentaryHasVouvher = false
    this.liveCommentaryList = []
    this.liveRemainCount = ''
    this.lastCommentaryId = ''
    this.HistoryNoMore = false
    this.dividerIndex = -1
    this.commentaryMessagePool = []
    this.restartMessageShow = false
    this.currentFixedType = 0
    this.currentFixedId = ''
    this.reqMarketIdsMap = {}
    this.event.markets = { map: {}, order: [] }
  },

  liveCommentaryInfo(data) {
    this.dividerIndex = data.length - 1
    this.liveCommentaryList.unshift(...data) // 推送消息列表
  },

  updateReqMarketIds(marketIds) {
    marketIds.forEach((id) => {
      this.reqMarketIdsMap[id] = 1
    })
  },

  removeReqMarketId(marketIds) {
    marketIds.forEach((id) => {
      delete this.reqMarketIdsMap[id]
    })
  },

  updateSubedMarketIds(marketId) {
    if (Array.isArray(marketId)) {
      marketId.forEach((key) => {
        this.subedMarketIds[key] = true
      })
    } else {
      this.subedMarketIds[marketId] = true
    }
  },

  setCommentaryMarkets(markets = []) {
    const eventMarkets = this.event.markets
    const { order, map } = turnCommentaryMarketsToMap(markets)
    order.forEach((marketId) => {
      const index = eventMarkets.order.findIndex((id) => +id === +marketId)
      if (index === -1) {
        eventMarkets.order.push(marketId)
        Vue.set(eventMarkets.map, marketId, map[marketId])
      } else {
        eventMarkets.order.splice(index, 1, marketId)
        Vue.set(eventMarkets.map, marketId, map[marketId])
      }
    })
  },

  updateCommentarySubStatus(data) {
    this.commentarySubStatus = data
  },
  updateCommentaryAnimStatus(data) {
    this.commentaryAnimStatus = data
  },
  updateCommentaryBotStatus(data) {
    this.commentaryBotStatus = data
  }
}
